import { render, staticRenderFns } from "./ForPersonalPage.vue?vue&type=template&id=74d73f68"
import script from "./ForPersonalPage.vue?vue&type=script&lang=js"
export * from "./ForPersonalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports